import Vue from 'vue';
import { Component, Emit, Prop } from 'vue-property-decorator';

@Component
export default class FilterbarComponent extends Vue {
    @Prop({ default: "" })
    buttonToolTip!: string;
    @Prop({ default: "" })
    placeholder!: string;
    
    //runtime
    filterText: string = "";

    doFilter() {
        console.log('doFilter:', this.filterText)
        this.onFilter(this.filterText);
    }

    resetFilter() {
        this.filterText = ''
        console.log('resetFilter')
    }

    @Emit("onFilter")
    onFilter(data) {
        console.log('emit onFilter');
    }
}
